export const ADD_NEW_CONNECTION = "ADD_NEW_CONNECTION";
export const REMOVE_CONNECTION = "REMOVE_CONNECTION";
